import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import ccremoteIcon from '../assets/ccremote-icon.png';
import { trackPageView } from '../utils/analytics';

const CCRemotePrivacy = () => {
  useEffect(() => {
    trackPageView('CC Remote Privacy Policy');
  }, []);

  return (
    <div className="privacy-container">
      <header className="privacy-header">
        <div className="app-info">
          <div className="app-icon">
            <img src={ccremoteIcon} alt="CC Remote" />
          </div>
          <div className="app-details">
            <h1>CC Remote</h1>
            <p>Privacy Policy</p>
          </div>
        </div>
        <Link to="/" className="back-link">← Back to Home</Link>
      </header>

      <main className="privacy-content">
        <div className="privacy-section">
          <h2>Information We Collect</h2>
          <p>CC Remote does not collect, store, or transmit any personal information. The app operates entirely within your local network and communicates only with the CC Remote server you configure.</p>
        </div>

        <div className="privacy-section">
          <h2>Network Communication</h2>
          <p>CC Remote connects to a CC Remote server running on your local network via WebSocket. All communication stays within your local network (or your own configured server). No data is sent to our servers or any third-party services.</p>
        </div>

        <div className="privacy-section">
          <h2>Local Network Discovery</h2>
          <p>The app uses Bonjour/mDNS to discover CC Remote servers on your local network. This discovery process is limited to your local network and does not communicate with any external servers.</p>
        </div>

        <div className="privacy-section">
          <h2>Data Storage</h2>
          <p>Server connection history and app preferences are stored locally on your device only. No data is backed up to or synced with external servers.</p>
        </div>

        <div className="privacy-section">
          <h2>Third-Party Services</h2>
          <p>CC Remote does not use any third-party analytics, advertising networks, or data collection services.</p>
        </div>

        <div className="privacy-section">
          <h2>Permissions</h2>
          <p>The app requests local network access permission to discover and connect to CC Remote servers on your network. No other sensitive permissions are required.</p>
        </div>

        <div className="privacy-section">
          <h2>Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at:</p>
          <p><strong>Email:</strong> feedback@peacetech.app</p>
        </div>

        <div className="privacy-section">
          <h2>Updates to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
          <p><strong>Last updated:</strong> March 2026</p>
        </div>
      </main>
    </div>
  );
};

export default CCRemotePrivacy;
